import React from 'react';
import { Divider } from '@mui/material';
import { registerColors } from '../../styles/colors';

interface OrDividerProps {
  text: string;
}

const OrDivider: React.FC<OrDividerProps> = ({ text }) => (
  <Divider
    textAlign="center"
    sx={{
      color: registerColors.dividerColor,
      mb: 3,
      mt: 0,
      '&::before, &::after': { borderColor: registerColors.dividerColor },
    }}
  >
    {text}
  </Divider>
);

export default OrDivider;
